import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";

import { Doughnut } from "react-chartjs-2";
import {
    Button,
    Block,
    BlockDes,
    BlockHead,
    Icon,
    Col,
    Row,
    PreviewAltCard,
} from "../../../components/Component";

import Head from "../../../layout/head/Head";
import OptionM from "../../components/DynmicOption/OptionM";
import OptionC from "../../components/DynmicOption/OptionC";
import OptionS from "../../components/DynmicOption/OptionS";
import AdminUserDataUpdateCount from "./AdminUserDataUpdateCount";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import OptionRS from "../../components/DynmicOption/OptionRS";

const AdminEmployemtCount = ({ ...props }) => {
    const [loading, setLoading] = useState(false);
    const [Statee, setStatee] = useState([]);
    const [transData, setTransData] = useState([]);
    const [onSearch, setonSearch] = useState(true);
    const [onSearchText, setSearchText] = useState("");
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [modal, setModal] = useState({
        add: false,
    });
  
    const today = new Date();
    const [lorder, setLorder] = useState(true);
    const [data, setData] = useState(transData);
    const [formData, setFormData] = useState({
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        tomonth: sessionStorage.getItem("CurrentMonth") === null ? today.getMonth() + 1 : sessionStorage.getItem("CurrentMonth"),
        todummymonth: sessionStorage.getItem("CurrentMonth2") === null ? month1[today.getMonth() + 1] : month1[sessionStorage.getItem("CurrentMonth2")],
        toyear: sessionStorage.getItem("CurrentYear") === null ? today.getFullYear() : sessionStorage.getItem("CurrentYear"),

        EmploymentRefId: 0,
        state: -1

    });
    const [userData, setuserData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    
    const [Edit, setEdit] = useState({
        edit: 0,
        submit: 0,
        open: 0
    })
    const [data2, setdata2] = useState({
        labels: ["Deaft", "Submitted", "Open"],
        dataUnit: "People",
        legend: false,
        datasets: [
            {
                borderColor: "#fff",
                backgroundColor: ["#f9db7b", "#1ee0ac", "#e85347",],
                data: [2, 2, 2],
            },
        ],
    })
    const tableRef = useRef(null);
    const getdata = async () => {
        const sendData = {

            CatgTypeId: Number(formData.state),
        }
     

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/Getreport', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
              
                    setData(data)
                    setStatee(data)
                    setLorder(false)
                })


    };

    const getdata2 = async () => {
        

        const sendData = {
            MonthId: Number(formData.month),
            Month: formData.state,
            YearId: Number(formData.year),
        }
    

        await fetch(process.env.REACT_APP_API_LINK + 'api/Payment/Dgecount', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

             
                    setEdit({
                        edit: data.edit,
                        submit: data.submit,
                        open: data.open
                    })
                    setdata2({
                        labels: ["Draft", "Submitted", "Open"],
                        dataUnit: "People",
                        legend: false,
                        datasets: [
                            {
                                borderColor: "#fff",
                                backgroundColor: ["#f9db7b", "#1ee0ac", "#e85347",],
                                data: [data.edit, data.submit, data.open],
                            },
                        ],
                    })
                })


    };
    const usergetdata = async () => {


        const sendData = {
            UserId: Number(localStorage.getItem("userId")),

        }
       /* //console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK + 'api/Payment/Getuser', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                   /* //console.log(data)*/
                    setuserData(data)

                })


    };

    const changedata = async (activestatus) => {
        setLorder(true)
        const sendData = {
            OrgId: Number(localStorage.getItem("orgId")),
            UserId: Number(localStorage.getItem("userId")),
        }


        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GetparametersNumber', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    var Maindata = data.filter(data => data.activeStatus === activestatus);

                    if (activestatus !== null) {
                        setTransData(Maindata)
                        setData(Maindata)
                        setCurrentPage(1)

                    }
                    else {
                        setTransData(data)
                        setData(data)
                        setCurrentPage(1)

                    }
                    setLorder(false)
                })


    };

    const onInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
       /* //console.log(formData)*/
    };
    const onInputChange2 = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };
    const onInputChange3 = (tomonth, toyear) => {
        setFormData({ ...formData, tomonth: tomonth, toyear: toyear });

    };
    const sortingFunc = (params) => {
        let defaultData = data;
        if (params === "asc") {
            let sortedData = [...defaultData].sort((a, b) => parseFloat(a.cloudMcatId) - parseFloat(b.cloudMcatId));
            setData([...sortedData]);
        } else if (params === "dsc") {
            let sortedData = [...defaultData].sort((a, b) => parseFloat(b.cloudMcatId) - parseFloat(a.cloudMcatId));
            setData([...sortedData]);
        }
    };

    // Changing state value when searching name
    useEffect(() => {
        if (onSearchText !== "") {
            const filteredObject = transData.filter((item) => {

                return item.organizationName.toLowerCase().includes(onSearchText.toLowerCase()) || item.phoneNo.toLowerCase().includes(onSearchText.toLowerCase()) || item.emailId.toLowerCase().includes(onSearchText.toLowerCase());
            });
            setData([...filteredObject]);
        }
        else {
            setData([...transData]);
        }

    }, [onSearchText]);


    useEffect(() => {

    
        usergetdata()

        //console.log()
    }, [])


    useEffect(() => {

        getdata()
        getdata2()

    }, [formData])






    return (
        <React.Fragment>
            <Head title="AllUser" />

            <Content>
               

                <Block>

                    <BlockHead size="lg">

                        <BlockDes className="text-soft">

                            <Row >

                                <Col xl="2" md="2">
                                    <td >
                                        <h5 style={{ color: '#798bff' }}>DGE Dashboard</h5>
                                    </td>
                                </Col> 
                                <Col xl="3" md="3" >

                                    <label style={{ color: 'black', fontSize: 15 }}>  State :  <label style={{ fontWeight: 'bold' }}><OptionRS catid="43" onInputChange={onInputChange} namemain="state" mainid="state" /></label></label>
                                </Col>
                                <Col xl="3" md="3" >
                                    <label style={{ color: 'black', fontSize: 15 }}>  <label style={{ fontWeight: 'bold' }}><OptionC onInputChange={onInputChange2} year={formData.year} month={formData.month} /></label></label>


                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col md="4" xxl="4">
                                    <PreviewAltCard border1={true} className="h-100">
                                        <h6 className="ff-base fw-medium"><b style={{ fontSize: 20 }}>  Summary</b> :<br /><br /> <small className="text-soft">The DGE Dashboard shows the data of employment exchange of a particular month

                                        </small></h6>
                                    </PreviewAltCard>
                                </Col>
                                <Col md="8" xxl="8">
                                    <PreviewAltCard border1={true} className="h-100">
                                        <Row>
                                            <Col md="2"></Col>
                                            <Col md="6">
                                                <div className="traffic-channel-group">

                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>
                                                            <b style={{ fontSize: 20 }}> Draft : <large style={{ marginLeft: 80 }}> {Edit.edit}</large> </b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>

                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>
                                                            <b style={{ fontSize: 20 }}> Submitted : <large style={{ marginLeft: 32 }}> {Edit.submit}</large></b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>
                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>
                                                            <b style={{ fontSize: 20 }}> Open  : <large style={{ marginLeft: 77 }}> {Edit.open}</large></b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>

                                                </div>
                                            </Col>
                                            <Col md="4">
                                                <div className="traffic-channel-doughnut-ck">
                                                    <Doughnut
                                                        className="analytics-doughnut"
                                                        data={data2}
                                                        options={{
                                                            legend: {
                                                                display: false,
                                                            },
                                                            rotation: -1.5,
                                                            cutoutPercentage: 70,
                                                            maintainAspectRatio: false,
                                                            tooltips: {
                                                                enabled: true,
                                                                backgroundColor: "#fff",
                                                                borderColor: "#eff6ff",
                                                                borderWidth: 2,
                                                                titleFontSize: 13,
                                                                titleFontColor: "#6783b8",
                                                                titleMarginBottom: 6,
                                                                bodyFontColor: "#9eaecf",
                                                                bodyFontSize: 12,
                                                                bodySpacing: 4,
                                                                yPadding: 10,
                                                                xPadding: 10,
                                                                footerMarginTop: 0,
                                                                displayColors: false,
                                                            },
                                                        }}
                                                    ></Doughnut>
                                                </div>

                                            </Col>
                                        </Row>
                                    </PreviewAltCard>

                                </Col>
                            </Row>
                        </BlockDes>


                    </BlockHead>
                    <hr />
                    <Row>
                        <Col md="2" lg="3">
                            <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>  <b style={{ fontSize: 18 }}>N--   Not submitted</b>
                        </Col>
                        <Col md="2" lg="3">
                            <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>  <b style={{ fontSize: 18 }}>D-- Draft</b>
                        </Col>
                        <Col md="2" lg="3">
                            <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>  <b style={{ fontSize: 18 }}> S-- Submitted</b>
                        </Col>
                       

                        <Col md="2" lg="3">
                    <DownloadTableExcel
                        filename="Employment Exchanges Report"
                        sheet="users"
                        currentTableRef={tableRef.current}
                    >
                        <Button style={{ float: "right",marginBottom:10 }} color="info" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                            </DownloadTableExcel>
                        </Col>
                    </Row>
                    <div className="table-responsive">
                        <table className="table table-orders" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0, border: '1px solid black' }}>
                           
                            <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                <tr style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }}>
                                    <th rowSpan="2" colSpan="2" style={{ textAlign: 'center', border: '1px solid black', verticalAlign: 'inherit', maxWidth:100 }}>
                                       
                                        Employment Exchanges\Returns

                                    </th>
                                    <th colSpan="9" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: 'orange', color: 'black' }}>
                                        Statistical Returns
                                    </th>
                                </tr>
                                <tr style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: 'orange', color: 'black' }}>
                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }}>
                                        ES1

                                    </th>
                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }}>
                                        ES2

                                    </th>
                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }}>
                                        ES3

                                    </th>
                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }}>
                                        ES4

                                    </th>


                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }}>
                                        ES5 Part1

                                    </th>
                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }}>
                                        ES5 Part2

                                    </th>
                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }}>
                                        ES6

                                    </th>
                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }}>
                                        ES7

                                    </th>
                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }}>
                                        ES8

                                    </th>

                                </tr>


                            </thead>
                            
                            {Statee.length > 0 ? Statee.map((data, index) =>
                                 <tr>
                                   
                              
                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit',  backgroundColor: '#eaf8dd', color: 'black' }}>
                                        {index + 1}

                                    </th>
                                    <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', backgroundColor: '#eaf8dd', color: 'black', maxWidth:150 }}>
                                        {data.catgType}

                                    </th>
                                    <td style={{ textAlign: 'center',  padding: 10, verticalAlign: 'inherit' }}>
                                        <AdminUserDataUpdateCount userId={data.langId} sno={index + 1} month={formData.month} year={formData.year} parent={1} AdminUserDataUpdateCount={AdminUserDataUpdateCount} />
                                    </td>
                                    <td style={{ textAlign: 'center',  padding: 10, verticalAlign: 'inherit' }}>
                                        <AdminUserDataUpdateCount userId={data.langId} sno={index + 1} month={formData.month} year={formData.year} parent={2} AdminUserDataUpdateCount={AdminUserDataUpdateCount} />
                                    </td>
                                    <td style={{ textAlign: 'center', padding: 10, verticalAlign: 'inherit' }}>
                                        <AdminUserDataUpdateCount userId={data.langId} sno={index + 1} month={formData.month} year={formData.year} parent={3} AdminUserDataUpdateCount={AdminUserDataUpdateCount} />
                                    </td>
                                    
                                    <td style={{ textAlign: 'center', padding: 10, verticalAlign: 'inherit' }}>
                                        <AdminUserDataUpdateCount userId={data.langId} sno={index + 1} month={formData.month} year={formData.year} parent={4} AdminUserDataUpdateCount={AdminUserDataUpdateCount} />
                                    </td>
                                    <td style={{ textAlign: 'center', padding: 10, verticalAlign: 'inherit' }}>
                                        <AdminUserDataUpdateCount userId={data.langId} sno={index + 1} month={formData.month} year={formData.year} parent={5} AdminUserDataUpdateCount={AdminUserDataUpdateCount} />
                                    </td>
                                    <td style={{ textAlign: 'center', padding: 10, verticalAlign: 'inherit' }}>
                                        <AdminUserDataUpdateCount userId={data.langId} sno={index + 1} month={formData.month} year={formData.year} parent={6} AdminUserDataUpdateCount={AdminUserDataUpdateCount} />
                                    </td>
                                    
                                    <td style={{ textAlign: 'center', padding: 10, verticalAlign: 'inherit' }}>
                                        <AdminUserDataUpdateCount userId={data.langId} sno={index + 1} month={formData.month} year={formData.year} parent={7} AdminUserDataUpdateCount={AdminUserDataUpdateCount} />
                                    </td>
                                    <td style={{ textAlign: 'center', padding: 10, verticalAlign: 'inherit' }}>
                                        <AdminUserDataUpdateCount userId={data.langId} sno={index + 1} month={formData.month} year={formData.year} parent={9} AdminUserDataUpdateCount={AdminUserDataUpdateCount} />
                                    </td>
                                    <td style={{ textAlign: 'center', padding: 10, verticalAlign: 'inherit' }}>
                                        <AdminUserDataUpdateCount userId={data.langId} sno={index + 1} month={formData.month} year={formData.year} parent={8} AdminUserDataUpdateCount={AdminUserDataUpdateCount} />
                                    </td>
                                    

                                </tr>

                                    



                            ) : (formData.state === -1 ? < h5 > Select A State To Get The Report</h5> : < h5 > Loading...</h5> )}
                          

                        
                        </table>

                    </div>




                </Block>




            </Content>

        </React.Fragment>
    );
};

export default AdminEmployemtCount;
